<template>
    <div class="bizcomp-fund-market white">
        <comp-title :title="title" />
        <div class="fund-market">
            <el-row class="fund-filter">
                <el-col v-if="isPublic" :span="24" class="btn-fund">
                    基金类型：
                    <el-radio-group v-model="activeType" size="mini">
                        <el-radio-button
                            v-for="item in fundTypes"
                            :key="item.val"
                            :label="item.val"
                        >
                            {{ item.text }}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col v-else :span="24" class="btn-fund">
                    基金策略类型：
                    <el-radio-group v-model="strategyType" size="mini">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button
                            v-for="item in strategyTypeList"
                            :key="item.strategycode"
                            :label="item.strategycode"
                        >
                            {{ item.strategyname }}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col v-if="isPublic" :span="24" class="btn-fund">
                    基金风险：
                    <el-radio-group v-model="fundRisk" size="mini">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button
                            v-for="risk in riskList"
                            :key="risk.subitem"
                            :label="risk.subitem"
                        >
                            {{ risk.subitemname }}风险
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col v-else :span="24" class="btn-fund">
                    基金风险：
                    <el-radio-group v-model="ismatch" size="mini">
                        <el-radio-button label="0">全部</el-radio-button>
                        <el-radio-button label="1">只看风险匹配</el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="24" class="btn-fund fund-manager-row">
                    <span class="fund-label">基金经理：</span>
                    <!-- 全部：单独一列 -->
                    <el-radio-group v-model="fundManager" size="mini" class="fund-manager-all">
                        <el-radio-button label="">全部</el-radio-button>
                    </el-radio-group>

                    <!-- 基金经理：真正的网格 -->
                    <el-radio-group v-model="fundManager" size="mini" class="fund-manager-list">
                        <el-radio-button
                            v-for="item in fundManagerList"
                            :key="item.managerid"
                            :label="item.managerid"
                        >
                            {{ item.managername }}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="24" class="btn-search">
                    查询条件：
                    <span v-for="tag in dynamicTags" :key="tag" style="display: inline-block">
                        <el-tag
                            v-if="tag"
                            closable
                            :disable-transitions="false"
                            v-on:close="handleClose(tag)"
                        >
                            {{ tag }}
                        </el-tag>
                    </span>
                    <el-autocomplete
                        v-model="searchText"
                        popper-class="my-autocomplete"
                        placeholder="请输入查询基金名称或基金代码"
                        class="input-search"
                        :popper-append-to-body="false"
                        size="small"
                        :fetch-suggestions="querySearchAsync"
                        v-on:select="handleSelect"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">
                                {{ item.value }}
                            </div>
                        </template>
                    </el-autocomplete>
                    <el-button
                        class="btn-search-icon"
                        icon="el-icon-search"
                        type="yellow"
                        size="small"
                        v-on:click="searchFund"
                    />
                </el-col>
                <el-col :span="24" class="btn-fund">
                    共有
                    <span class="red">{{ allPage }}</span>
                    条基金
                </el-col>
            </el-row>
            <fund-risk-filter v-if="isPublic" :qryall="ismatch" v-on:qry-change="qryChange" />
            <template v-if="isSplitAllMode">
                <fund-list
                    ref="normalFundList"
                    :has-load="hasLoad"
                    :fund-info="normalFund"
                    tab-index="999"
                    list-type="normal"
                    :all-page="String(normalFund.length)"
                    :show-pagination="false"
                    no-fund-msg="暂无非货基金"
                    v-on:new-fund="newFund"
                    v-on:fund-continue="fundBuy"
                    v-on:sort-change="handleFundSortChange"
                />
                <fund-list
                    ref="currencyFundList"
                    :has-load="hasLoad"
                    :fund-info="currencyFund"
                    tab-index="5"
                    list-type="currency"
                    :all-page="String(currencyFund.length)"
                    :show-pagination="false"
                    :hide-currency-stage="hideCurrencyStage"
                    no-fund-msg="暂无货币基金"
                    v-on:new-fund="newFund"
                    v-on:fund-continue="fundBuy"
                    v-on:sort-change="handleFundSortChange"
                />
            </template>
            <fund-list
                v-else
                ref="fundList"
                :has-load="hasLoad"
                :fund-info="fund"
                :tab-index="activeType"
                :all-page="allPage"
                :page="pageoffset"
                :hide-currency-stage="hideCurrencyStage"
                v-on:new-fund="newFund"
                v-on:fund-continue="fundBuy"
                v-on:sort-change="handleFundSortChange"
            />
        </div>
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        ></fund-sdx-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundList from "@/components/fund/dcFundList";
import fundRiskFilter from "@/components/form/fundRiskFilter";
import fundApi from "@/api/fund";
import fundSdxDialog from "@/components/form/fundSdxDialog";
import { getRiskFilter, isValidProfessionalInvestor } from "@/util";

export default {
    name: "FundMarket",
    components: {
        fundList,
        fundRiskFilter,
        fundSdxDialog
    },
    mixins: [mixin],
    data() {
        return {
            ismatch: getRiskFilter(), // 是否只看风险匹配
            searchText: "", // 搜索文本内容
            fund: [], // 基金信息
            normalFund: [], // 全部页分列表展示时的非货基金
            currencyFund: [], // 全部页分列表展示时的货币基金
            normalFundSource: [], // 非货基金原始顺序，供表头排序重置
            currencyFundSource: [], // 货币基金原始顺序，供表头排序重置
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            sortField: "", // 排序字段
            sortOrder: "", // 排序方向 "" 不排序 "ascending" 升序 "descending" 降序
            url: "", // 当前页面路由命名
            isPublic: true, // 是否公募
            activeType: "", // 基金类型
            hasLoad: false, // 是否已经查询数据
            sdxFundInfo: {},
            sdxDialogVisible: false,
            fundTypes: [],
            dynamicTags: [], // 筛选条件
            riskList: [],
            fundclass: "", // 公私募标记
            strategyType: "", // 基金策略类型
            strategyTypeList: [], // 策略类型数据
            fundRisk: "", // 基金风险
            fundManager: "", // 当前选中基金经理
            fundManagerList: [], // 基金经理列表
            autoTradeHandledKey: ""
        };
    },
    computed: {
        isSplitAllMode() {
            // 10102050=0只控制基金超市“全部”页拆分展示，其他tab仍走原分页列表。
            return (
                this.isPublic &&
                this.fundclass !== "1" &&
                this.activeType === "999" &&
                this.$cache.getCompanyInfoParam("10102050") === "0"
            );
        },
        hideCurrencyStage() {
            // 10102049=0时货币基金阶段收益列隐藏，阶段收益为0展示“--”由列表组件兜底。
            return this.$cache.getCompanyInfoParam("10102049") === "0";
        }
    },
    watch: {
        "$route.fullPath"() {
            const routeFundcode = this.initRouteFundcode();
            this.pageoffset = 1;
            this.doAction(routeFundcode || "");
        },
        activeType(val, from) {
            if (!val) {
                this.$set(this.dynamicTags, 0, "");
            } else {
                const _x = this.fundTypes.find((risk) => {
                    return risk.val === val;
                });
                this.$set(this.dynamicTags, 0, _x.text);
            }
            this.pageoffset = 1;
            this.doAction();
        },
        fundRisk(val, from) {
            if (!val) {
                this.$set(this.dynamicTags, 1, "");
            } else {
                const _x = this.riskList.find((risk) => {
                    return risk.subitem === val;
                });
                this.$set(this.dynamicTags, 1, _x ? _x.subitemname + "风险" : "");
            }
            this.pageoffset = 1;
            this.doAction();
        },
        strategyType(val, from) {
            if (!val) {
                this.$set(this.dynamicTags, 0, "");
            } else {
                const _x = this.strategyTypeList.find((strategy) => {
                    return strategy.strategycode == val;
                });
                this.$set(this.dynamicTags, 0, _x.strategyname);
            }
            this.pageoffset = 1;
            this.doAction();
        },
        ismatch(val, from) {
            if (this.isPublic) {
                return;
            }
            if (!val) {
                this.$set(this.dynamicTags, 1, "");
            } else {
                const text = val == "0" ? "" : "只看风险匹配";
                this.$set(this.dynamicTags, 1, text);
            }
            this.pageoffset = 1;
            this.doAction();
        },
        fundManager(val) {
            if (!val) {
                this.$set(this.dynamicTags, 2, "");
            } else {
                const manager = this.fundManagerList.find((item) => item.managerid === val);
                this.$set(this.dynamicTags, 2, `基金经理：${manager.managername}`);
            }
            this.pageoffset = 1;
            this.doAction();
        }
    },
    async created() {
        this.$store.commit("updateLoadFund", false);
        this.url = this.$route.name;
        this.isPublic = this.$route.name == "fund" || this.$route.name == "glist";
        this.getFundManagerList();
        if (this.isPublic) {
            const info = this.$cache.getUser();
            if (!isValidProfessionalInvestor()) {
                this.ismatch = info.ismatch || "1";
            }
            this.riskList = this.$cache.getDict("110143");
        } else {
            this.getFundStrategyType();
        }
        this.riskList = this.$cache.getDict("110143");
        this.fundclass = this.$util.getFundClass();
        this.initRouteFundcode();
        this.doAction();
        let fundclassList =
            (this.$cache.getParamValue("fund_market") &&
                this.$cache.getParamValue("fund_market").fundshowtypes) ||
            [];
        // 判断脚本是否有热销基金这项
        let hasTargetItem = fundclassList.some((item) => item.subitem === "47223");
        // 处理基金超市展示的列表项
        const convertedApiTabs = fundclassList.map((item) => ({
            val: item.subitem != "47223" ? item.subitem : "hot",
            text: item.subitemname
        }));
        if (hasTargetItem) {
            const res = await fundApi.getFundLists({
                tagids: "47223",
                pagesize: 10,
                pagenum: 1
            });
            // 如果没有热销基金 不展示此tab
            if (res.data.list.length == 0) {
                hasTargetItem = false;
                convertedApiTabs.shift();
            }
        }
        this.fundTypes =
            this.fundclass == "1"
                ? JSON.parse(JSON.stringify(this.$util.getConfig().privateFundTypes))
                : convertedApiTabs;
        this.activeType = this.fundclass == "1" ? "999" : hasTargetItem ? "hot" : "999";
        this.fundTypes.forEach((item) => {
            if (!item.val) {
                item.val = "999";
            }
        });
    },
    mounted() {
        const routeFundcode = this.initRouteFundcode();
        if (routeFundcode) {
            this.doAction(routeFundcode);
        }
    },
    methods: {
        getRouteFundcode() {
            return this.$util.filterCode((this.$route.query && this.$route.query.fundcode) || "");
        },
        initRouteFundcode() {
            const fundcode = this.getRouteFundcode();
            this.searchText = fundcode;
            this.autoTradeHandledKey = "";
            return fundcode || "";
        },
        getAutoTradeInfo() {
            const tradeRouteName = this.$route.query.autotrade || "";
            const fundcode = this.getRouteFundcode();
            const tradeWay =
                tradeRouteName === "buyfund"
                    ? "20,22"
                    : tradeRouteName === "generalbuy"
                    ? "59"
                    : "";
            if (!tradeWay || !fundcode) {
                return null;
            }
            return {
                fundcode,
                tradeWay,
                key: `${this.$route.name}_${tradeRouteName}_${fundcode}`
            };
        },
        handleAutoTrade(list) {
            const autoTradeInfo = this.getAutoTradeInfo();
            if (!autoTradeInfo || this.autoTradeHandledKey === autoTradeInfo.key) {
                return;
            }
            this.autoTradeHandledKey = autoTradeInfo.key;
            const targetFund = list.find((item) => item.fundcode === autoTradeInfo.fundcode);
            if (!targetFund) {
                this.$message.info("未查询到符合条件的数据！");
                return;
            }
            this.$nextTick(() => {
                const triggerResult = this.triggerTradeByFundCode(
                    autoTradeInfo.tradeWay,
                    autoTradeInfo.fundcode
                );
                if (triggerResult.status === "missing") {
                    this.fundBuy(autoTradeInfo.tradeWay, targetFund);
                }
            });
        },
        triggerTradeByFundCode(tradeWay, fundcode) {
            // 分列表模式下不再只有一个fundList，自动带入交易需同时兼容单表和两张拆分表。
            const refs = [
                this.$refs.fundList,
                this.$refs.normalFundList,
                this.$refs.currencyFundList
            ];
            for (let i = 0; i < refs.length; i++) {
                const ref = refs[i];
                if (!ref || !ref.triggerTradeByFundCode) continue;
                const triggerResult = ref.triggerTradeByFundCode(tradeWay, fundcode);
                if (triggerResult.status !== "missing") {
                    return triggerResult;
                }
            }
            return { status: "missing" };
        },
        // 处理基金适当性信息
        fundBuy(way, val) {
            this.sdxFundInfo = {};
            // 普通购买/定投
            if (way === "20,22") {
                val._url = "buyfund";
                val.proto = "buy";
            } else if (way === "59") {
                val._url = "generalbuy";
                val.proto = "plan";
            }
            this.$util.fundRiskCheck(this, val, (res) => {
                if (res) {
                    const isNeedSdxCheck = this.$util.isNeedSdxCheck(val);
                    if (!isNeedSdxCheck) {
                        val.way = way; // 添加 way 字段，供 buyCompDC.vue 计算 isPwdCheck
                        this.$util.grantTradeSdxAccessAndStoreFund(val._url, val);
                        this.$router.push({ name: val._url, query: { fundcode: val.fundcode } });
                        return;
                    }
                    this.$util.getSdxProtocol(res, (data) => {
                        if (data) {
                            const _x = Object.assign({}, data, { way: way });
                            this.sdxFundInfo = _x;
                            this.sdxDialogVisible = true;
                        }
                    });
                }
            });
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            this.$util.grantTradeSdxAccessAndStoreFund(this.sdxFundInfo._url, this.sdxFundInfo);
            this.$router.push({
                name: this.sdxFundInfo._url,
                query: { fundcode: this.sdxFundInfo.fundcode }
            });
        },
        // 改变风险过滤规则
        qryChange(val) {
            this.ismatch = val;
            this.pageoffset = 1;
            this.doAction();
        },
        // 搜索基金
        searchFund() {
            this.pageoffset = 1;
            this.doAction(this.searchText);
        },
        // 获取策略类型数据
        async getFundStrategyType() {
            const res = await fundApi.getFundStrategyType();
            this.strategyTypeList = res.data || [];
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
            // this.pageoffset = 1;
            // this.doAction();
        },
        // 获取新一页数据
        newFund(val) {
            this.pageoffset = Number(val);
            this.doAction();
        },
        // 表头排序
        handleFundSortChange({ prop, order, listType }) {
            if (this.isSplitAllMode && listType) {
                this.sortSplitFundList(prop, order, listType);
                return;
            }
            if (order) {
                this.sortField = prop;
                this.sortOrder = order;
            } else {
                this.sortField = "";
                this.sortOrder = "";
            }
            this.pageoffset = 1;
            this.doAction();
        },
        sortSplitFundList(prop, order, listType) {
            // 分列表使用999全量数据，本地排序需保留接口原始顺序用于取消排序恢复。
            const source =
                listType === "currency" ? this.currencyFundSource : this.normalFundSource;
            const targetKey = listType === "currency" ? "currencyFund" : "normalFund";
            if (!prop || !order) {
                this[targetKey] = source.slice();
                return;
            }
            const direction = order === "ascending" ? 1 : -1;
            this[targetKey] = source.slice().sort((a, b) => {
                return this.compareFundValue(a[prop], b[prop], direction);
            });
        },
        compareFundValue(a, b, direction) {
            const aEmpty = a === "" || a === null || a === undefined;
            const bEmpty = b === "" || b === null || b === undefined;
            if (aEmpty && bEmpty) return 0;
            if (aEmpty) return 1;
            if (bEmpty) return -1;
            const aNum = Number(a);
            const bNum = Number(b);
            if (Number.isFinite(aNum) && Number.isFinite(bNum)) {
                return (aNum - bNum) * direction;
            }
            return String(a).localeCompare(String(b), "zh-CN") * direction;
        },
        // 获取基金信息
        async getFund(val, cb) {
            const _this = this;
            const exType = ["999", "0", "zghr", "hot"];
            const splitAllMode = this.isSplitAllMode && !cb;

            let orderfield = "";
            let isasc = "";
            if (this.sortField) {
                if (this.sortField === "nav") {
                    orderfield = this.activeType === "5" ? "fundincomeunit" : "nav";
                } else if (this.sortField === "dayfloatprofit") {
                    orderfield = this.activeType === "5" ? "growthrate" : "dayfloatprofit";
                } else {
                    orderfield = this.sortField;
                }
                isasc = this.sortOrder === "ascending" ? "1" : "0";
            }

            const _x = {
                tagids: this.activeType === "hot" ? "47223" : "",
                fundshowtype: exType.includes(this.activeType) ? "" : this.activeType,
                ismatch: this.ismatch,
                strategylevel1: this.strategyType,
                risklevel: this.fundRisk,
                orderfield: orderfield,
                isasc: isasc,
                valuagrbuystate: this.url === "glist" ? "1" : "",
                keyword: val || (this.searchText ? this.searchText : ""),
                // 参数10102050=0时，全部页按999口径拉全量后前端拆货币/非货两张表。
                pagesize: splitAllMode ? 999 : cb ? 20 : this.pagecount,
                pagenum: splitAllMode ? 1 : val ? 1 : this.pageoffset,
                tradingmethod: this.$util.getConfig().systemtype,
                mrfflag: this.activeType === "zghr" ? "1" : undefined,
                fundclass: this.fundclass,
                managercode: this.fundManager
            };
            const res = await fundApi.getFundLists(_x);
            this.hasLoad = true;
            this.$store.commit("updateLoadFund", true);
            if (res.data) {
                if (cb) {
                    cb.call(_this, res.data.list);
                } else {
                    if (this.pageoffset == 1) {
                        this.allPage = "0";
                    }
                    _this.fund = res.data.list;
                    if (splitAllMode) {
                        this.splitFundList(res.data.list || []);
                    } else {
                        this.clearSplitFundList();
                    }
                    if (this.activeType === "hot" && !_this.fund.length) {
                        _this.activeType = "999";
                        _this.fundTypes.shift();
                        _this.doAction();
                    }
                    if (_this.isPublic) {
                        // 记录过滤状态
                        const info = _this.$cache.getUser();
                        info.ismatch = _this.ismatch;
                        _this.$store.dispatch("setInfo", info);
                    }
                    _this.allPage = res.data.total.toString();
                    _this.handleAutoTrade(res.data.list || []);
                }
            }
        },
        splitFundList(list) {
            // fundshowtype=5为货币基金，其余均归入非货基金，避免同一产品跨表重复展示。
            const normalFund = [];
            const currencyFund = [];
            list.forEach((item) => {
                if (item.fundshowtype === "5") {
                    currencyFund.push(item);
                } else {
                    normalFund.push(item);
                }
            });
            this.normalFundSource = normalFund.slice();
            this.currencyFundSource = currencyFund.slice();
            this.normalFund = normalFund;
            this.currencyFund = currencyFund;
        },
        clearSplitFundList() {
            this.normalFundSource = [];
            this.currencyFundSource = [];
            this.normalFund = [];
            this.currencyFund = [];
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 500);
        },
        // 切换类型tab
        handleClick(target) {
            this.pageoffset = 1;
            this.doAction();
        },
        // 搜索选项关闭处理
        handleClose(val) {
            // 查询条件标签按固定下标维护，避免按展示文案判断时误删其他筛选项。
            if (val === this.dynamicTags[2]) {
                this.fundManager = "";
                return;
            }
            if (this.isPublic) {
                if (val === this.dynamicTags[1]) {
                    this.fundRisk = "";
                } else {
                    this.activeType = "";
                }
            } else {
                if (val == "只看风险匹配") {
                    this.ismatch = "0";
                } else {
                    this.strategyType = "";
                }
            }
        },
        async getFundManagerList() {
            const res = await fundApi.qryFundManagers();
            this.fundManagerList = res.data || [];
        }
    }
};
</script>

<style lang="scss">
.white {
    background: #ffffff;
    border: 1px solid #f1f1f1;
    margin-bottom: 20px;
    padding-bottom: 20px;
}
.fund-title {
    display: flex;
    padding: 20px 0;
    align-items: center;
    justify-content: space-between;
    .fund-ic {
        width: 30px;
        height: 30px;
        margin-right: 12px;
        margin-top: 3px;
    }
    .fund-search {
        .input-search {
            width: 400px;
            vertical-align: middle;
            .search-icon {
                margin: 0 5px;
                height: 40px;
                color: #666666;
            }
            .el-input__inner {
                height: 40px;
                line-height: 40px;
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }
            .el-input-group__append {
                background-color: var(--color-primary);
                color: $text-color6;
                font-size: $f20;
                border-color: var(--color-primary);
                padding: 0 10px;
            }
        }
        .fund-total {
            margin-left: 30px;
            margin-right: 15px;
            font-size: 18px;
            line-height: 40px;
            font-weight: normal;
            color: var(--color-primary);
        }
    }
}
.type-bg {
    background: #edf5fc;
}
.fund-type {
    padding: 0 20px;
    height: 60px;
    opacity: 1;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    background: linear-gradient(90deg, #1e3b7b -1%, #e40c1a 101%);
    .el-tabs__header {
        margin: 0;
    }
    .el-tabs__nav-wrap:after {
        background: transparent;
        height: 1px;
    }
    .el-tabs__nav-scroll {
        line-height: 60px;
        padding: 0 20px;
        .el-tabs__active-bar {
            height: 3px;
            background: var(--color-primary);
        }
        .el-tabs__item {
            padding: 0 15px;
            font-size: $f20;
            font-weight: normal;
            color: rgba(255, 255, 255, 0.8);
            text-align: center;
            min-width: 82px;
            &.is-active {
                min-width: 88px;
                font-size: $f24;
                font-weight: 500;
                color: #ffffff;
            }
            .el-badge__content.is-fixed {
                top: 10px;
                right: 1px;
            }
        }
    }
    .el-tabs__content {
        padding: 0 0 20px;
        .fund-offset .cell {
            padding: 0 10px 0 20px;
        }
        .fund-arr {
            padding: 0 20px;
            .cell {
                padding: 0;
            }
        }
    }
}
.bizcomp-fund-market .risk-filter-text {
    border: none;
    margin: 0;
}
</style>

<style lang="scss" scoped>
/* 整行 */
.fund-manager-row {
    display: flex;
    align-items: flex-start;
    white-space: normal;
}

/* 左侧 label */
.fund-manager-row .fund-label {
    flex-shrink: 0;
    line-height: 28px;
    margin-right: 4px;
}

/* 全部：固定宽度，占一列 */
.fund-manager-all {
    flex-shrink: 0;
}

/* 基金经理区域：真正的网格 */
.fund-manager-list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
}

/* 每行 8 个基金经理 */
.fund-manager-list .el-radio-button {
    // width: calc(100% / 8);
    width: 100px;
    box-sizing: border-box;
    margin-bottom: 6px;
}

/* 按钮样式 */
.fund-manager-row .el-radio-button__inner {
    width: 100%;
    padding: 6px 4px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
